import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getList,
  getRemoteList,
  setPaginaAtual,
  setListLoading,
  addNewError,
  syncNotificationsFromLocalStorage,
} from './erroActions';
import { toastr } from 'react-redux-toastr';
import ReactTableGT2A from '../common/grid/gridReactTable';
import PremiumTableShell from '../common/grid/premiumTableShell';
import ProcessingOverlay from '../common/components/processingOverlay';
import TicketSuporteForm from '../ticket_suporte/ticketSuporteForm';
import axiosInstance from '../main/axios';
import { formatMensagemErroExibicao, humanizarMensagemErro, mensagemAtendeBusca } from '../common/utils/erroMensagemUtils';
import {
  OS_STATUS_BADGE,
  OS_STATUS_LABELS,
  TICKET_STATUS_BADGE,
  TICKET_STATUS_LABELS,
} from '../notifications/components/notificationListUtils';
import { openFromNotification } from '../manutencao/ordem_servico/ordemServicoActions';
import { validaPermissao } from '../auth/permissaoActions';

import configLocal from '../configuracao/configLocal';

moment.locale('pt-br');

const defaultDataInicio = () =>
  moment()
    .subtract(1, 'day')
    .format('YYYY-MM-DD');
const defaultDataFim = () => moment().format('YYYY-MM-DD');

const dateInputStyle = {
  width: '150px',
  height: '32px',
  padding: '4px 8px',
  fontSize: '12px',
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
};

const messageInputStyle = {
  width: '220px',
  height: '32px',
  padding: '4px 10px',
  fontSize: '12px',
  border: '1px solid #bfd0e0',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  color: '#475569',
};

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

const printButtonStyle = {
  height: '36px',
  width: '36px',
  padding: 0,
  border: '1px solid #bfd0e0',
  borderRadius: '10px',
  backgroundColor: '#ffffff',
  color: '#475569',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

class ControladorErroList extends Component {
  constructor(props) {
    super(props);

    this.carregarErro = this.carregarErro.bind(this);
    this.fetchList = this.fetchList.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.handleBuscaMensagemChange = this.handleBuscaMensagemChange.bind(this);
    this.imprimirRelatorio = this.imprimirRelatorio.bind(this);
    this.handleShowOs = this.handleShowOs.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleOpenExistingTicket = this.handleOpenExistingTicket.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
    this.buildErrorAsNotification = this.buildErrorAsNotification.bind(this);

    this.state = {
      processingCarregar: false,
      dataInicio: defaultDataInicio(),
      dataFim: defaultDataFim(),
      buscaMensagem: '',
      showTicketModal: false,
      selectedError: null,
      abrindoOs: false,
    };

    // Watchers para mudanças de filtro (grupo/numCont)
    this.filterWatcherId = 0;
    this.currentGrupo = null;
    this.currentNumCont = null;
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  componentWillUnmount() {
    // TEMPORARIAMENTE DESABILITADO
    // // Remover listener do WebSocket
    // socketService.removeEventListener('lista_erros_atualizada', this.handleErrorListUpdate);
    // Remover watcher de filtro
    if (this.filterWatcherId) clearInterval(this.filterWatcherId);
  }

  componentDidMount() {
    // Carregar notificações do localStorage ao iniciar
    this.props.syncNotificationsFromLocalStorage();

    // TEMPORARIAMENTE DESABILITADO - WebSocket será usado apenas no sistema de notificações
    // // Adicionar listener para a lista de erros atualizada via WebSocket
    // this.handleErrorListUpdate = () => {
    //   this.props.getList();
    // };
    // socketService.addEventListener('lista_erros_atualizada', this.handleErrorListUpdate);

    // // Verificar se a conexão WebSocket está ativa
    // if (!socketService.socket || !socketService.connected) {
    //   socketService.connect();
    // }

    // Iniciar watcher para alterações de filtro (grupo/numCont)
    try {
      this.currentGrupo = configLocal.getConfig('grupo');
      this.currentNumCont = configLocal.getConfig('numCont');
      this.filterWatcherId = setInterval(() => {
        const novoGrupo = configLocal.getConfig('grupo');
        const novoNumCont = configLocal.getConfig('numCont');
        if (novoGrupo !== this.currentGrupo || novoNumCont !== this.currentNumCont) {
          this.currentGrupo = novoGrupo;
          this.currentNumCont = novoNumCont;
          // Resetar paginação e recarregar lista
          this.props.setPaginaAtual(0);
          this.fetchList();
        }
      }, 300);
    } catch (_) {}
  }

  componentWillMount() {
    this.fetchList();
  }

  fetchList() {
    this.props.setListLoading(true);
    return this.props
      .getList()
      .then(() => this.props.setListLoading(false))
      .catch(() => this.props.setListLoading(false));
  }

  carregarErro() {
    this.setState({ processingCarregar: true });
    this.props
      .getRemoteList()
      .then(() => {
        this.fetchList();
        toastr.success('Sucesso', 'Operação Realizada com sucesso.');
      })
      .catch(() => {
        toastr.error('Erro', 'Sem conexão');
      })
      .finally(() => {
        this.setState({ processingCarregar: false });
      });
  }

  handleDateRangeChange(field, value) {
    this.props.setPaginaAtual(0);
    this.setState({ [field]: value });
  }

  handleBuscaMensagemChange(event) {
    this.props.setPaginaAtual(0);
    this.setState({ buscaMensagem: event.target.value });
  }

  filtrarLista(lista) {
    const { dataInicio, dataFim, buscaMensagem } = this.state;
    const termoBusca = (buscaMensagem || '').trim();

    return (lista || []).filter(row => {
      const dataErro = moment(row.data_erro);
      if (dataInicio && dataErro.isValid() && dataErro.isBefore(moment(dataInicio), 'day')) {
        return false;
      }
      if (dataFim && dataErro.isValid() && dataErro.isAfter(moment(dataFim), 'day')) {
        return false;
      }

      if (termoBusca) {
        const mensagemExibicao =
          row.mensagem_humana ||
          humanizarMensagemErro(row.mensagem) ||
          formatMensagemErroExibicao(row.mensagem) ||
          '';
        if (!mensagemAtendeBusca(mensagemExibicao, termoBusca)) {
          return false;
        }
      }

      return true;
    });
  }

  getTicketInfo(error) {
    if (!error || !error.ticket_id) return null;
    return {
      id: error.ticket_id,
      status: error.ticket_status,
      titulo: error.ticket_titulo,
    };
  }

  getOsInfo(error) {
    if (!error || !error.os_id) return null;
    return {
      id: error.os_id,
      numero: error.os_numero,
      status: error.os_status,
    };
  }

  buildErrorAsNotification(error) {
    return {
      id_erro: error.id_erro,
      id: error.id_erro,
      controlador_id: error.controlador_id,
      grupo_fisico_id: error.grupo_fisico_id || configLocal.getConfig('grupo'),
      numero_controlador: error.numero_controlador || configLocal.getConfig('numCont'),
      mensagem:
        error.mensagem_humana ||
        humanizarMensagemErro(error.mensagem) ||
        formatMensagemErroExibicao(error.mensagem) ||
        error.mensagem,
      data_erro: error.data_erro,
      hora_erro: error.hora_erro,
    };
  }

  handleShowOs(error) {
    if (this.state.abrindoOs) return;

    const osInfo = this.getOsInfo(error);
    this.setState({ abrindoOs: true });
    this.props
      .openFromNotification(this.buildErrorAsNotification(error), osInfo)
      .then(() => {
        if (this.props.history) {
          this.props.history.push('/manutencao-os');
        }
      })
      .finally(() => this.setState({ abrindoOs: false }));
  }

  handleOpenExistingTicket(error, ticketInfo) {
    if (!ticketInfo || !ticketInfo.id) return;

    axiosInstance
      .get(`/ticket_suporte/${ticketInfo.id}`)
      .then(resp => {
        const ticket = resp.data || {};
        this.setState({
          showTicketModal: true,
          selectedError: {
            id: ticket.id,
            titulo: ticket.titulo || '',
            descricao: ticket.descricao || '',
            status: ticket.status || 'ABERTO',
            controlador_id: ticket.controlador_id || error.controlador_id || '',
            grupo_fisico_id: ticket.grupo_fisico_id || error.grupo_fisico_id,
            numero_controlador: error.numero_controlador || configLocal.getConfig('numCont'),
            controlador_erro_id: ticket.controlador_erro_id || error.id_erro,
            isFromError: false,
          },
        });
      })
      .catch(() => {
        this.setState({
          showTicketModal: true,
          selectedError: {
            id: ticketInfo.id,
            titulo: ticketInfo.titulo || `Ticket #${ticketInfo.id}`,
            descricao: '',
            status: ticketInfo.status || 'ABERTO',
            controlador_id: error.controlador_id || '',
            grupo_fisico_id: error.grupo_fisico_id || configLocal.getConfig('grupo'),
            numero_controlador: error.numero_controlador || configLocal.getConfig('numCont'),
            controlador_erro_id: error.id_erro,
            isFromError: false,
          },
        });
      });
  }

  handleShowTicketModal(error) {
    this.setState({
      showTicketModal: true,
      selectedError: {
        titulo: `Erro no Controlador ${error.numero_controlador || configLocal.getConfig('numCont')}`,
        descricao: `Mensagem de Erro: ${
          error.mensagem_humana || humanizarMensagemErro(error.mensagem) || error.mensagem
        }

Detalhes:
- Data: ${moment(error.data_erro).format('DD/MM/YYYY')}
- Hora: ${error.hora_erro}
- Controlador: ${error.numero_controlador || configLocal.getConfig('numCont')}
- Grupo Físico: ${error.grupo_fisico_id || configLocal.getConfig('grupo')}`,
        grupo_fisico_id: error.grupo_fisico_id || configLocal.getConfig('grupo'),
        numero_controlador: error.numero_controlador || configLocal.getConfig('numCont'),
        controlador_erro_id: error.id_erro,
        controlador_id: error.controlador_id || '',
        isFromError: true,
      },
    });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedError: null }, () => {
      this.fetchList();
    });
  }

  renderTicketCell(error) {
    const ticketInfo = this.getTicketInfo(error);

    if (ticketInfo) {
      const badgeClass = TICKET_STATUS_BADGE[ticketInfo.status] || 'ticket-badge--gray';
      const statusLabel = TICKET_STATUS_LABELS[ticketInfo.status] || ticketInfo.status;
      return (
        <button
          type="button"
          className={`notif-modal-os-badge notif-modal-os-badge--linked notif-modal-os-badge--btn erro-geral-grid-badge ${badgeClass}`}
          onClick={() => this.handleOpenExistingTicket(error, ticketInfo)}
          title={`Ticket #${ticketInfo.id} · ${statusLabel}`}
        >
          <span className="notif-modal-os-badge-label">
            <i className="fa fa-ticket-alt" aria-hidden="true" /> #{ticketInfo.id} · {statusLabel}
          </span>
        </button>
      );
    }

    return (
      <button
        type="button"
        className="notif-modal-os-badge notif-modal-os-badge--none notif-modal-os-badge--btn erro-geral-grid-badge"
        onClick={() => this.handleShowTicketModal(error)}
        title="Abrir ticket de suporte"
      >
        <span className="notif-modal-os-badge-status">
          <i className="fa fa-ticket-alt" aria-hidden="true" />
          Abrir ticket
        </span>
      </button>
    );
  }

  renderOsCell(error) {
    const { abrindoOs } = this.state;
    const osInfo = this.getOsInfo(error);

    if (osInfo) {
      const badgeClass = OS_STATUS_BADGE[osInfo.status] || 'os-badge--gray';
      const statusLabel = OS_STATUS_LABELS[osInfo.status] || osInfo.status;
      return (
        <button
          type="button"
          className={`notif-modal-os-badge notif-modal-os-badge--linked notif-modal-os-badge--btn erro-geral-grid-badge ${badgeClass}`}
          onClick={() => this.handleShowOs(error)}
          disabled={abrindoOs}
          title={`OS ${osInfo.numero} · ${statusLabel}`}
        >
          <span className="notif-modal-os-badge-label">
            <i className="fa fa-clipboard-list" aria-hidden="true" /> {osInfo.numero} · {statusLabel}
          </span>
        </button>
      );
    }

    return (
      <button
        type="button"
        className="notif-modal-os-badge notif-modal-os-badge--none notif-modal-os-badge--btn erro-geral-grid-badge"
        onClick={() => this.handleShowOs(error)}
        disabled={abrindoOs}
        title="Abrir ordem de serviço"
      >
        <span className="notif-modal-os-badge-status">
          <i className="fa fa-clipboard-list" aria-hidden="true" />
          Abrir OS
        </span>
      </button>
    );
  }

  imprimirRelatorio() {
    const controladorId = configLocal.getConfig('cont');
    const numeroControlador = configLocal.getConfig('numCont') || controladorId;

    if (!controladorId || controladorId === 0) {
      alert('Selecione um controlador para imprimir.');
      return;
    }

    const listaFiltrada = this.filtrarLista(this.props.list || []);
    if (!listaFiltrada.length) {
      alert('Nenhum dado para imprimir com os filtros atuais.');
      return;
    }

    const { dataInicio, dataFim, buscaMensagem } = this.state;
    const { config } = this.props;
    const usaTickets = config && config.modulo_tickets;
    const usaManutencao = config && config.modulo_manutencao && validaPermissao('CadOrdemServico');
    let printWindow = null;

    try {
      printWindow = window.open('', '_blank');
      if (!printWindow) {
        alert('Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.');
        return;
      }

      const formatTicketCol = error => {
        const ticket = this.getTicketInfo(error);
        if (!ticket) return '—';
        const statusLabel = TICKET_STATUS_LABELS[ticket.status] || ticket.status;
        return `#${ticket.id} · ${statusLabel}`;
      };

      const formatOsCol = error => {
        const os = this.getOsInfo(error);
        if (!os) return '—';
        const statusLabel = OS_STATUS_LABELS[os.status] || os.status;
        return `${os.numero} · ${statusLabel}`;
      };

      let rowsHtml = '';
      listaFiltrada.forEach(row => {
        const mensagem =
          row.mensagem_humana ||
          humanizarMensagemErro(row.mensagem) ||
          formatMensagemErroExibicao(row.mensagem) ||
          '';
        rowsHtml += `
          <tr>
            <td>${escapeHtml(moment(row.data_erro).format('DD/MM/YYYY'))}</td>
            <td>${escapeHtml(row.hora_erro || '')}</td>
            <td style="text-align:left;">${escapeHtml(mensagem)}</td>
            ${usaManutencao ? `<td>${escapeHtml(formatOsCol(row))}</td>` : ''}
            ${usaTickets ? `<td>${escapeHtml(formatTicketCol(row))}</td>` : ''}
          </tr>
        `;
      });

      const filtroMensagem = (buscaMensagem || '').trim()
        ? `<p><strong>Busca:</strong> ${escapeHtml(buscaMensagem.trim())}</p>`
        : '';

      const html = `
        <html>
          <head>
            <title>Registro de Defeitos - Controlador ${escapeHtml(numeroControlador)}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; color: #333; font-size: 11px; }
              h2 { margin-bottom: 8px; }
              p { margin: 4px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 16px; }
              th, td { border: 1px solid #ddd; padding: 6px; text-align: center; }
              th { background: #f2f2f2; font-weight: bold; }
            </style>
          </head>
          <body>
            <h2>Registro de Defeitos</h2>
            <p><strong>Controlador:</strong> ${escapeHtml(numeroControlador)}</p>
            <p><strong>Período:</strong> ${escapeHtml(moment(dataInicio).format('DD/MM/YYYY'))} a ${escapeHtml(moment(dataFim).format('DD/MM/YYYY'))}</p>
            ${filtroMensagem}
            <p><strong>Registros:</strong> ${listaFiltrada.length}</p>
            <table>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Hora</th>
                  <th>Mensagem</th>
                  ${usaManutencao ? '<th>OS</th>' : ''}
                  ${usaTickets ? '<th>Ticket</th>' : ''}
                </tr>
              </thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </body>
        </html>
      `;

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => {
        try {
          printWindow.print();
        } catch (e) {}
        try {
          printWindow.close();
        } catch (e) {}
      }, 50);
    } catch (error) {
      console.error('Erro ao imprimir registro de defeitos:', error);
      if (printWindow && !printWindow.closed) {
        try {
          printWindow.close();
        } catch (e) {}
      }
      alert('Erro ao gerar impressão. Tente novamente.');
    }
  }

  render() {
    moment.locale('pt-br');

    const contErro = this.filtrarLista(this.props.list || []);
    const paginaAtual = this.props.paginaAtual;
    const { processingCarregar, selectedError } = this.state;
    const loadingLista = this.props.loading && !processingCarregar;
    const showProcessing = processingCarregar || loadingLista;
    const { config } = this.props;
    const usaTickets = config && config.modulo_tickets;
    const usaManutencao = config && config.modulo_manutencao && validaPermissao('CadOrdemServico');

    const columns = [
      {
        Header: 'Data',
        accessor: 'data_erro',
        minWidth: 100,
        maxWidth: 140,
        filterable: false,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
      },
      {
        Header: 'Hora',
        accessor: 'hora_erro',
        minWidth: 80,
        maxWidth: 120,
        className: 'column_grid column_center',
        filterable: false,
        resizable: true,
      },
      {
        Header: 'Mensagem',
        accessor: 'mensagem',
        minWidth: 240,
        className: 'column_grid column_left',
        style: {
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        },
        filterable: false,
        resizable: true,
        Cell: ({ original }) =>
          original.mensagem_humana ||
          humanizarMensagemErro(original.mensagem) ||
          formatMensagemErroExibicao(original.mensagem) ||
          '-',
      },
    ];

    if (usaManutencao) {
      columns.push({
        Header: 'OS',
        accessor: 'os_id',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => this.renderOsCell(error),
      });
    }

    if (usaTickets) {
      columns.push({
        Header: 'Ticket',
        accessor: 'ticket_id',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => this.renderTicketCell(error),
      });
    }

    const toolbarButton = (
      <button
        type="button"
        className="btn btn-success"
        style={{
          height: '36px',
          borderRadius: '10px',
          fontSize: '13px',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '0 14px',
          border: 'none',
          boxShadow: '0 2px 8px rgba(40,167,69,0.15)',
        }}
        onClick={this.carregarErro}
        disabled={showProcessing}
        title="Busca erros do controlador para gravar no banco e exibe"
      >
        <i className={`fa ${showProcessing ? 'fa-spinner fa-spin' : 'fa-download'}`} />
        <span>Buscar do Controlador</span>
      </button>
    );

    const toolbarFilters = (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        <input
          type="text"
          value={this.state.buscaMensagem}
          onChange={this.handleBuscaMensagemChange}
          placeholder="Buscar mensagem..."
          style={messageInputStyle}
        />
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>De</label>
        <input
          type="date"
          value={this.state.dataInicio}
          onChange={e => this.handleDateRangeChange('dataInicio', e.target.value)}
          style={dateInputStyle}
        />
        <label style={{ fontSize: '12px', color: '#64748b', margin: 0, fontWeight: 600 }}>Até</label>
        <input
          type="date"
          value={this.state.dataFim}
          onChange={e => this.handleDateRangeChange('dataFim', e.target.value)}
          style={dateInputStyle}
        />
        {toolbarButton}
        <button
          type="button"
          className="btn btn-default"
          title="Imprimir lista filtrada"
          onClick={this.imprimirRelatorio}
          disabled={showProcessing}
          style={printButtonStyle}
        >
          <i className="fa fa-print" aria-hidden="true" />
        </button>
      </div>
    );

    return (
      <div className="table-container" style={{ marginTop: '20px', width: '100%' }}>
        <ProcessingOverlay
          show={showProcessing}
          message={
            processingCarregar ? (
              <>
                Carregando erros do controlador...
                <small>Comunicando com a central e o equipamento.</small>
              </>
            ) : (
              <>
                Carregando lista de erros...
                <small>Aguarde enquanto os registros são consultados.</small>
              </>
            )
          }
          tagline="Registro de Defeitos"
        />

        <style>{`
          .controlador-erro-premium-table .ReactTable .rt-th.column_center,
          .controlador-erro-premium-table .ReactTable .rt-td.column_center {
            justify-content: center;
            text-align: center;
          }

          .controlador-erro-premium-table .ReactTable .rt-th .rt-resizable-header-content,
          .controlador-erro-premium-table .ReactTable .rt-th .rt-th-content {
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .controlador-erro-premium-table .ReactTable .rt-td,
          .controlador-erro-premium-table .ReactTable .rt-th {
            font-size: 12px;
          }

          .controlador-erro-premium-table .erro-geral-grid-badge {
            width: auto;
            max-width: 118px;
            min-height: 28px;
            height: auto;
            padding: 5px 8px;
            font-size: 11px;
            font-weight: 600;
            gap: 5px;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            line-height: 1.25;
            white-space: normal;
          }

          .controlador-erro-premium-table .erro-geral-grid-badge .notif-modal-os-badge-label,
          .controlador-erro-premium-table .erro-geral-grid-badge .notif-modal-os-badge-status {
            font-size: 11px;
            line-height: 1.25;
            justify-content: center;
            text-align: center;
            gap: 4px;
          }

          .controlador-erro-premium-table .erro-geral-grid-badge .notif-modal-os-badge-status i,
          .controlador-erro-premium-table .erro-geral-grid-badge .notif-modal-os-badge-label i {
            font-size: 11px;
            flex-shrink: 0;
          }
        `}</style>

        <div className="controlador-erro-premium-table">
          <PremiumTableShell
            summary={`${contErro.length} erro(s) exibido(s)`}
            toolbarRight={toolbarFilters}
            tableMinWidth={usaManutencao || usaTickets ? 900 : 0}
          >
            <ReactTableGT2A
              data={contErro}
              columns={columns}
              className="-striped -highlight"
              defaultPageSize={15}
              showPagination
              filterable={false}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
              style={{
                fontSize: '13px',
                width: '100%',
              }}
            />
          </PremiumTableShell>
        </div>
        {usaTickets && this.state.showTicketModal && selectedError && (
          <TicketSuporteForm
            key={selectedError.id || selectedError.controlador_erro_id || 'new-ticket'}
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={selectedError}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.controladorErroCad.list,
  paginaAtual: state.controladorErroCad.paginaAtual,
  loading: state.controladorErroCad.loading,
  config: state.auth.config,
});
const mapDispatchToProps = dispatch => ({
  dispatch,
  ...bindActionCreators(
    {
      getList,
      getRemoteList,
      setPaginaAtual,
      setListLoading,
      addNewError,
      syncNotificationsFromLocalStorage,
      openFromNotification,
    },
    dispatch,
  ),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ControladorErroList),
);
